import React, { Component, useState} from 'react';
import {
    Col, Row, Card, CardBody, Button, Form, FormGroup, Label
} from 'reactstrap';
import { Field, reduxForm,} from 'redux-form';
import { connect } from 'react-redux'
import './style.scss';
import Modal from '../../../../components/UI/Modal/Modal'
import { changeStatus, addStatus, findEditData, saveEditedData, checkStatus } from './helper'
import ScorecardSetupForm from './scorecardSetupForm/index'
import withAuth from '../../../../components/Services/WithAuth';
import { Preloading } from '../../../../components/UI/Preloader/action';
import * as corporateOnboardingAction from '../action';
import { fetchRiskgradeCategory } from '../../../../components/Services/action';
import { setPageView, goolgeAnalyticsEvents } from '../../../../components/GoogleAnalytics/index';
import{ transferCorporateUserSaga, fetchEwsSelectPlanName } from '../action';
import Select from 'react-select';

class ScorecardSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false,
            riskLevels: [],
            financialRiskFactors: [],
            nonFinancialRiskFactors: [],
            productData: [],
            selectedProduct: {},
            scoreCardData: [],
            showModal: false,
            infoModal: false,
            body: "",
            initState: null,
            ewsPlans: this.props.fetchEwsSelectPlanNameList ? this.props.fetchEwsSelectPlanNameList.map(item=>({value: item.id, label: item.planName})) : [],
            ewsOptInRows: (this.props.editdata && this.props.editdata.data && this.props.editdata.data.ewsOnboardingData) ? this.props.editdata.data.ewsOnboardingData.map(itm=>itm.productId) :  [],
            ewsOnboardingData: (this.props.editdata && this.props.editdata.data && this.props.editdata.data.ewsOnboardingData) ? this.props.editdata.data.ewsOnboardingData : [],
            getEwsOnboardingData: (this.props.editdata && this.props.editdata.data && this.props.editdata.data.ewsOnboardingData) ? this.props.editdata.data.ewsOnboardingData : [],
        }
    }

    componentDidMount() {
        setPageView('/Admin/create/corporate/scorecardsetup', document.location.href)
        const { activeProgressTab, productSetup, history } = this.props
        if (Object.keys(productSetup).length === 0 && productSetup.constructor === Object) {
            history.push('../companysetup')
        } else {
            activeProgressTab('setup-progress-element current')
        }
        this.props.fetchEwsSelectPlanName();
        this.props.fetchRiskgradeCategory()
        let products
        if (this.props.scorecardData && this.props.scorecardData.length !== 0) {
            products = checkStatus(this.props.productSetup, this.props.scorecardData, this.props.editdata)
            this.setState({
                scoreCardData: this.props.scorecardData
            })
        }
        else {
            products = addStatus(this.props.productSetup, false)//this.props.productSetup
        }
        this.setState({
            productData: products
        })
    }
    componentDidUpdate(prevProps) {
        if (this.props.fetchEwsSelectPlanNameList !== prevProps.fetchEwsSelectPlanNameList) {
            const ewsPlanNameList = this.props.fetchEwsSelectPlanNameList
            let filteredPlanList = [];
            ewsPlanNameList.forEach(item => {
                filteredPlanList.push({value: item.id, label: item.planName})
            })
            this.setState({
                ewsPlans: filteredPlanList
            })
        }
        if (this.props.riskLevels && this.props.riskLevels !== prevProps.riskLevels) {
            this.setState({
                riskLevels: this.props.riskLevels
            })
        }
        if (this.props.riskFactors !== prevProps.riskFactors) {
            this.setState({
                riskFactors: this.props.riskFactors,
                // initState: findEditData(this.state.selectedProduct.id, this.state.scoreCardData)
            })
        }
        if (Object.keys(this.props.corporateOnboardingSuccess).length && this.props.corporateOnboardingSuccess !== prevProps.corporateOnboardingSuccess) {
            goolgeAnalyticsEvents('Admin', 'Onboarding Corporate', 'Create New Corporate', '');
            this.props.preloading(false)
            this.setState({
                infoModal: true,
                body: <div><h5 className="text-Success"><i className="fa fa-check-circle"></i>Success</h5>
                    <p>Corporate Onboarding successful</p>
                    <Button color="info" className="mt-5" onClick={this.handleSuccessClose}>Ok</Button>
                </div>
            }, () => this.toggleModal(),
                this.props.setCreditSetup(''))
        }
        else if (Object.keys(this.props.corporateOnboardingFailure).length && this.props.corporateOnboardingFailure !== prevProps.corporateOnboardingFailure) {
            this.props.preloading(false)
            this.setState({
                infoModal: true,
                body: <div><h5 className="text-danger"><i className="fa fa-exclamation-triangle"></i>&nbsp;Failure</h5>
                    <p>Failure in Onboarding!</p>
                    <p>{(this.props.corporateOnboardingFailure.response && this.props.corporateOnboardingFailure.response.data) ? this.props.corporateOnboardingFailure.response.data.message : "Something went wrong! Please try again."}</p>
                    <Button color="info" className="mt-5" onClick={this.handleWarningClose}>Ok</Button>
                </div>
            }, () => this.toggleModal())
        }
        if (Object.keys(this.props.editCorporateOnboardingSuccess).length && this.props.editCorporateOnboardingSuccess !== prevProps.editCorporateOnboardingSuccess) {
            this.props.preloading(false)
            this.setState({
                infoModal: true,
                body: <div><h5 className="text-Success"><i className="fa fa-check-circle"></i>Success</h5>
                    <p>Corporate Onboarding Edit successful</p>
                    <Button color="info" className="mt-5" onClick={this.handleSuccessClose}>Ok</Button>
                </div>
            }, () => this.toggleModal(),
                this.props.setCreditSetup(''))
        }
        else if (Object.keys(this.props.editCorporateOnboardingFailure).length && this.props.editCorporateOnboardingFailure !== prevProps.editCorporateOnboardingFailure) {
            this.props.preloading(false)
            this.setState({
                infoModal: true,
                body: <div><h5 className="text-danger"><i className="fa fa-exclamation-triangle"></i>&nbsp;Failure</h5>
                    <p>Failure in Corporate Onboarding Edit! &nbsp; {(this.props.editCorporateOnboardingFailure.response && this.props.editCorporateOnboardingFailure.response.data) ? this.props.editCorporateOnboardingFailure.response.data.message : "Something went wrong! Please try again."}</p>
                    <Button color="info" className="mt-5" onClick={this.handleWarningClose}>Ok</Button>
                </div>
            }, () => this.toggleModal())
        }
    }

    componentWillUnmount() {
        this.props.saveScorecardData(this.state.scoreCardData)

    }

    handleModalClosed = () => {
        this.setState(prevState => ({
            body: null
        }))
    }

    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
        }))
    }

    saveData = (values) => {
        let object = values
        object.productId = this.state.selectedProduct.id
        this.setState({
            productData: changeStatus(this.state.productData, this.state.selectedProduct),
            scoreCardData: saveEditedData(this.state.scoreCardData, object, this.props.riskFactors, this.state.selectedProduct.sectionList),
            initState: null
        }, () => {
            this.props.saveScorecardData(this.state.scoreCardData)
        })

    }



    createScorecard = (data) => {
        this.props.fetchRiskfactors(data.sectionList)//pass data.sectionList
        this.setState({
            selectedProduct: data,
            initState: null
        })
        this.toggleModal();
    }

    editScoreCard = (data) => {
        this.setState({
            selectedProduct: data,
            initState: findEditData(data.id, this.state.scoreCardData)
        })
        this.props.fetchRiskfactors(data.sectionList)
        this.toggleModal()
    }

    cancel = () => {
        this.setState({
            initState: null
        })
    }

    handleFinish = () => {
        if (this.getProductCount() === this.getScorecardCount()) {
            let data = {};
            data.corporate = this.props.companySetup.corporate[0];
            data.deletedCompanyDetails = this.props.companySetup.detetedCompanyNameDetails;
            data.deletedUserDetails = this.props.companySetup.deletedUserDetails;
            data.mandatoryMisOrderId = this.props.isMandatoryMisOrderId;
            let obj = {
                corporateDetails: data,
                productList: this.props.productSetup,
                scorecardList: this.props.scorecardData,
                credits: this.props.creditSetup,
                misFieldList: this.props.misFieldSetup,
                ewsOnboardingData: this.state.ewsOnboardingData
            }
            if (this.props.match.params.corporateId) {
                this.props.corporateOnboardingEdit(obj);
            }
            else {
                this.props.corporateOnboarding(obj);
           }
            this.props.preloading(true)
        }
        else {

            this.setState({
                infoModal: true,
                body: <div><h5 className="text-danger"><i className="fa fa-exclamation-triangle"></i>&nbsp;Failure</h5>
                    <p className="text-danger">Scorecard of all the products should be set</p>
                    <Button color="info" className="mt-5" onClick={this.handleWarningClose}>Ok</Button>
                </div>
            }, () => this.toggleModal())
        }


    }
    handleWarningClose = () => {
        this.toggleModal();
        this.setState({
            infoModal: false
        })
    }
    handleSuccessClose = () => {
        this.setState({
            infoModal: false
        }, () => this.toggleModal(), this.props.history.push('/corporate/list'))
    }
    getScorecardCount = () => {

        let count = 0;
        this.state.scoreCardData.forEach((item) => {
            if (item.enabled) {
                ++count;
            }
        })
        return count
    }

    getProductCount = () => {
        let count = 0;
        this.state.productData.forEach((item) => {
            if (item.enabled) {
                ++count;
            }
        })
        return count;
    }

    handlePlan=(event,data)=>{
        this.ewsObjectList({productId:data.id,planId:event.value});
    }

    getModalBody = () => {
        let form = null;
        if (this.state.showModal) {
            if (this.state.infoModal) {
                form = this.state.body;
            } else {
                form = <ScorecardSetupForm
                    toggle={this.toggleModal}
                    riskLevels={this.state.riskLevels}
                    saveData={(values) => this.saveData(values)}
                    editdata={this.state.initState}
                    riskfactors={this.props.riskFactors}
                    cancel={this.cancel}
                />
            }
        }
        return form;
    }

    adjustWidth(input,data) {
        if(input.target.value.length>0){
        const valueLength = input.target.value.length;
        const minWidth = 60; 
        const maxWidth = 80; 
        const width = Math.min(Math.max(valueLength * 10, minWidth), maxWidth); 
        input.target.style.width = width + 'px';
        input.target.value !=="" && this.ewsObjectList({productId:data.id, maxEwsCount:input.target.value});
        }else{
            input.target.style.width = '130px';
        }
    }

    resetWidth(input) {
        if(input.target.value.length>0){
        input.target.style.width = '60px';
        }else{
            input.target.style.width = '130px';
        }
    }

    handleRadioButtonChange =(e,rowElement) => {
        let ewsOptIn=e.target.value;
        const ewsOptedRows=this.state.ewsOptInRows;
        let filteredEwsOptedRows=[];
        ewsOptIn === 'yes' ? (filteredEwsOptedRows= [...ewsOptedRows,rowElement.id]) : ewsOptedRows.filter((item)=>(item !== rowElement.id) && filteredEwsOptedRows.push(item)); 

        this.setState({
            ewsOptInRows: filteredEwsOptedRows
        })
        ewsOptIn==='no' && this.removeEwsOnboardingPlan(rowElement.id, filteredEwsOptedRows)
    }

    ewsObjectList = (obj) => {
        let {productId,planId,maxEwsCount}=obj;
        let optedOnboardingData=this.state.ewsOnboardingData;
        let filteredEwsObjList = [];
        
            optedOnboardingData.length > 0 ? (optedOnboardingData.forEach(item=>{
                if(item.productId===obj.productId){
                    if(!!planId){
                        return  item.planId = planId;
                    }else if(!!maxEwsCount){
                        return item.maxEwsCount = Number(maxEwsCount);
                    }
                    else{
                        return;
                    }
                }else if(optedOnboardingData.filter(item=>item.productId===productId).length===0){
                filteredEwsObjList = [...optedOnboardingData,obj];
            }
            else{return} 
            
            })) : optedOnboardingData=[obj];
        
        
            this.setState({
                ewsOnboardingData : filteredEwsObjList.length > 0 ? filteredEwsObjList : optedOnboardingData
            });
    }

    removeEwsOnboardingPlan = (productId, filteredEwsOptedRows) =>{
        let optedOnboardingData=this.state.ewsOnboardingData;
        let filteredEwsObjList = [];
        optedOnboardingData.forEach(item=>(item.productId !== productId) && (filteredEwsObjList=[...filteredEwsObjList,item]));
        if(filteredEwsOptedRows.length === 0){
            this.setState({
                ewsOnboardingData : []
            }); 
        }else{
        this.setState({
            ewsOnboardingData : filteredEwsObjList.length > 0 ? filteredEwsObjList : optedOnboardingData
        });
    }
    }

    render() {
        let products;
        if (this.state.productData) {
            products = this.state.productData.map((data, index) => {
                if (data.enabled) {
                    return (
                        <li className="px-3 mb-3" key={index}>
                            <Row className="d-flex align-items-center">
                                <Col sm="3">{data.name}</Col>
                                <Col sm="2">
                                    <Form>
                                    <div><h6>EWS OptIn</h6>
                                        <Label check>
                                            <Field className="input-type-radio radioYes" component="input" type="radio" name={`option-${index}`}value="yes" onChange={(event) => this.handleRadioButtonChange(event, data)} checked={(this.state.ewsOptInRows.find(itm=>itm===data.id) && this.state.getEwsOnboardingData && this.state.getEwsOnboardingData.find(itm=>itm.productId===data.id))}/>{' '}Yes
                                        </Label>
                                            &nbsp;&nbsp;
                                        <Label check>
                                            <Field className="input-type-radio radioNo" component="input" type="radio" name={`option-${index}`}value="no"onChange={(event) => this.handleRadioButtonChange(event, data)} />{' '}No
                                        </Label>
                                    </div>
                                    </Form>
                                </Col>
                                {this.state.ewsOptInRows.filter(item=>item===data.id).length > 0 && <React.Fragment> <Col sm="4">
                                    <Select
                                        value={this.state.getEwsOnboardingData.find(itm=>itm.productId === data.id) && this.state.ewsPlans.find(i=>i.value===this.state.getEwsOnboardingData.find(itm=>itm.productId === data.id).planId)}
                                        onChange={(event)=>this.handlePlan(event,data)}
                                        options={this.state.ewsPlans}
                                        placeholder="Select Plan...">
                                    </Select>
                                </Col>
                                <Col sm="3">
                                    {(this.state.getEwsOnboardingData && this.state.getEwsOnboardingData.find(itm=>itm.productId === data.id) && this.state.getEwsOnboardingData.find(itm=>itm.productId === data.id).maxEwsCount) 
                                    ? 
                                    (<input min='1' className='setMaxEwsCount' type="number" placeholder="Max EWS Count" onInput={(e)=>this.adjustWidth(e,data)} onFocus={(e)=>this.adjustWidth(e,data)} onBlur={(e)=>this.resetWidth(e)} defaultValue={this.state.getEwsOnboardingData && this.state.getEwsOnboardingData.find(itm=>itm.productId === data.id) && this.state.getEwsOnboardingData.find(itm=>itm.productId === data.id).maxEwsCount} style={{ width: '60px' }}/>)
                                    :
                                     (<input min='1' className='setMaxEwsCount' type="number" placeholder="Max EWS Count" onInput={(e)=>this.adjustWidth(e,data)} onFocus={(e)=>this.adjustWidth(e,data)} onBlur={(e)=>this.resetWidth(e)} defaultValue={this.state.getEwsOnboardingData && this.state.getEwsOnboardingData.find(itm=>itm.productId === data.id) && this.state.getEwsOnboardingData.find(itm=>itm.productId === data.id).maxEwsCount} />)}
                                </Col> </React.Fragment>}
                                <Col sm="3">{data.counterpartyType}</Col>
                                <Col sm="3">{data.sectionList.length} Section(s)</Col>
                                <Col sm="2">{data.turnAroundTime} days</Col>
                                <Col sm="2">₹ {data.price}</Col>
                                <Col sm="2">{data.status ?
                                    <i className="icon-edit border border-primary radius-4 p-2 font-size-16" color="primary" onClick={() => this.editScoreCard(data)}></i> :
                                    <Button type="button" size="sm" color="primary" className="w-100" onClick={() => this.createScorecard(data)}>
                                        Set Scorecard
                                </Button>}
                                </Col>
                            </Row>
                        </li>
                    )
                }
            })
        }

        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                </div>
                <h5>Scorecard Setup</h5>

                <Card className="pb-70">
                    <CardBody>
                        <section>
                            <div className="header-blue p-3 text-primary font-weight-bold mb-3">Products [{this.getProductCount()}]</div>
                            <ul>
                                {products}
                            </ul>
                        </section>
                    </CardBody>
                </Card>
                <Modal show={this.state.showModal} className={this.state.infoModal ? 'Modal' : 'Large-Modal'} >
                    {this.getModalBody()}
                </Modal>
                <footer className="bg-light footer w-100 text-center">
                    <Button color="primary" onClick={this.handleFinish}>Finish</Button>
                </footer>


            </Col>
        );
    }
}    

ScorecardSetup = reduxForm({
    form: 'ewsOptInForm'
})(ScorecardSetup);

const mapStateToProps = (state, ownProps) => ({
    editdata: state.corporateOnBoardingCreate.editData,
    riskLevels: state.commonReducer.riskLevels,
    riskFactors: state.corporateOnBoardingCreate.riskFactors,
    riskFactorsError: state.corporateOnBoardingCreate.riskFactorsError,
    productSetup: state.corporateOnBoardingCreate.productSetup,
    scorecardData: state.corporateOnBoardingCreate.scorecardData,
    corporateOnboardingSuccess: state.corporateOnBoardingCreate.corporateOnboardingSuccess,
    corporateOnboardingFailure: state.corporateOnBoardingCreate.corporateOnboardingFailure,
    companySetup: state.corporateOnBoardingCreate.companySetup,
    editCorporateOnboardingSuccess: state.corporateOnBoardingCreate.editCorporateOnboardingSuccess,
    editCorporateOnboardingFailure: state.corporateOnBoardingCreate.editCorporateOnboardingFailure,
    creditSetup: state.corporateOnBoardingCreate.creditSetup,
    misFieldSetup:state.corporateOnBoardingCreate.misFieldSetupData,
    fetchEwsSelectPlanNameList: state.corporateOnBoardingCreate.fetchEwsSelectPlanNameSuccess,
    isMandatoryMisOrderId:state.corporateOnBoardingCreate.isMandatoryMisOrderIdData,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchRiskgradeCategory: () => { dispatch(fetchRiskgradeCategory()); },
    fetchRiskfactors: (sectionList) => { dispatch(corporateOnboardingAction.fetchRiskfactors(sectionList)) },
    corporateOnboarding: (data) => { dispatch(corporateOnboardingAction.CorporateOnboarding(data)) },
    saveScorecardData: (data) => { dispatch(corporateOnboardingAction.saveScorecardData(data)) },
    corporateOnboardingEdit: (data) => { dispatch(corporateOnboardingAction.corporateOnboardingEdit(data)) },
    setCreditSetup: (data) => { dispatch(corporateOnboardingAction.setCreditSetup(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    fetchEwsSelectPlanName: (data) => { dispatch(fetchEwsSelectPlanName(data)) }

})

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(ScorecardSetup))
